const minWidth = 150;

const InventorySummaryColumns = [
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerIdName',
    headerName: 'Inventory Owner ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inventoryOwnerShortName',
    headerName: 'Inventory Owner',
    minWidth,
  },
  {
    field: 'locationIdName',
    headerName: 'Location ID',
    minWidth,
  },
  {
    field: 'locationShortName',
    headerName: 'Location',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'productIdName',
    headerName: 'Product ID',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'productShortName',
    headerName: 'Product',
    minWidth,
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inTransitVol',
    headerName: 'Intransit Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'availableVol',
    headerName: 'Available Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'availableReservedVol',
    headerName: 'Available Reserved Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'inTransitReservedVol',
    headerName: 'Intransit Reserved Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'totalVol',
    headerName: 'Total Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'loadableVol',
    headerName: 'Loadable Vol. (bbl)',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'daysSupply',
    headerName: 'Days Supply',
    minWidth,
    type: 'number',
  },
  {
    field: 'uom',
    headerName: 'UOM',
    minWidth,
  },
  {
    field: 'ton',
    headerName: 'Ton',
    minWidth,
    type: 'number',
  },
  {
    cellClassName: 'css-heap-redact',
    field: 'sitVol',
    headerName: 'SIT Vol. (bbl)',
    minWidth,
    type: 'number',
  },
];

export default InventorySummaryColumns;
